import type { ReactNode } from 'react';
import s from './ui.module.css';

const tone = { error: s.alertError, success: s.alertSuccess, info: s.alertInfo, warning: s.alertWarning } as const;

export function Alert({ kind = 'info', children }: { readonly kind?: keyof typeof tone; readonly children: ReactNode }) {
  return (
    <div className={[s.alert, tone[kind]].join(' ')} role={kind === 'error' ? 'alert' : 'status'}>
      {children}
    </div>
  );
}
